export enum REAL_ESTATE_FILE_TYPE {
    VENTURE_LOGO = 'VENTURE_LOGO',
    BANNER = 'BANNER',
    GALLERY = 'GALLERY',
    BLUE_PRINT = 'BLUE_PRINT',
    CATALOG = 'CATALOG',
}
